import TypeBenneDetailController from './type.benne.detail.controller';

export default {
    template: require('./type.benne.detail.tpl.html'),
    controller: TypeBenneDetailController,
    bindings: {}
};
